class LazyVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var videoFallback = this.querySelector('.lazy-video-fallback');
    var videoElement = this.querySelector('video');

    // Respect reduced-motion: poster only, no download.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (videoElement) videoElement.remove();
      if (videoFallback) videoFallback.style.display = 'block';
      return;
    }

    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer,
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.querySelectorAll('source')) {
            var videoSource = video.target.querySelectorAll('source')[source];
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          videoElement = video.target.querySelector('video');
          videoFallback = video.target.querySelector('.lazy-video-fallback');

          if (!videoElement) {
            lazyVideoObserver.unobserve(video.target);
            return;
          }

          videoElement.load();

          // Low Power Mode / autoplay blocked → poster fallback
          videoElement.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              videoElement.remove();
              if (videoFallback) videoFallback.style.display = 'block';
            }
          });

          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideoObserver.observe(this);
  }
}

customElements.define('lazy-video', LazyVideo);
